import { Accordion } from 'flowbite-react';
const VisionMultimodalAiFAQ: React.FC = () => {
    return (
        <>
            <Accordion>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                         What is computer vision, and how does it differ from traditional image processing?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Computer vision uses deep learning models to understand and interpret visual data, recognizing objects, detecting anomalies, and extracting meaning from images and videos. Unlike rule-based image processing, CV systems learn patterns from data, making them adaptable and highly accurate for complex real-world scenarios.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What is multimodal AI, and why does it matter?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           Multimodal AI combines multiple data types, vision, text, audio, and sensor data, to create richer contextual understanding. For example, analyzing product images alongside customer reviews, or combining thermal imaging with equipment logs for predictive maintenance. This cross-modal intelligence unlocks insights that single-modality systems miss.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Can computer vision models run on edge devices, or do they require cloud infrastructure?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           Both! We optimize models for edge deployment using techniques like quantization, pruning, and ONNX/TensorRT conversion, enabling real-time inference on cameras, drones, IoT devices, and mobile hardware. For high-throughput scenarios, we also design hybrid edge-cloud architectures.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you handle data privacy and compliance for vision systems?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            We implement privacy-by-design principles: on-device processing for sensitive data, anonymization techniques (face blurring, de-identification), federated learning for distributed training, and audit trails for regulated industries like healthcare and finance. All deployments meet GDPR, HIPAA, and industry-specific compliance requirements.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       What industries benefit most from computer vision and multimodal AI?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                    <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                      <ul className="list">
                        <li>Manufacturing: Defect detection, quality control, predictive maintenance</li>
                        <li>Retail: Visual search, shelf monitoring, customer behavior analysis</li>
                        <li>Healthcare: Medical imaging, diagnostic assistance, patient monitoring</li>
                        <li>Logistics: Warehouse automation, package sorting, vehicle tracking</li>
                        <li>Security: Surveillance, threat detection, access control</li>
                        <li>Agriculture: Crop monitoring, yield prediction, pest detection</li>
                      </ul>
                    </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How long does a typical computer vision POC take?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            A standard proof of concept (POC) for computer vision runs 4-6 weeks. It includes data collection/annotation, model training/fine-tuning, performance validation, and integration testing. For multimodal projects involving vision & language, expect 6-8 weeks to account for fusion architecture design and testing.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       Do you provide explainability for computer vision models?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           Yes. We implement explainable AI (XAI) techniques like Grad-CAM, LIME, and attention visualization to show which image regions influence model decisions. This is critical for regulated industries, debugging model behavior, and building trust with end-users.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       Can you integrate computer vision with our existing systems (ERP, MES, CRM)?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Absolutely. We build REST APIs, streaming pipelines, and webhook integrations to connect vision systems with enterprise platforms like SAP, Salesforce, Oracle, and custom MES/SCADA systems. Real-time alerts, batch processing, and dashboard visualizations are all supported.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
            </Accordion>
        </>
    );
};

export default VisionMultimodalAiFAQ;
